/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeastEmployeeDocument = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        employee_id: {
    type: 'number',
    isRequired: true,
},
        expiration_date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        license: {
    type: 'string',
    isRequired: true,
},
        approval: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'string',
    isRequired: true,
},
        document_name: {
    type: 'string',
    isRequired: true,
},
        document_path: {
    type: 'string',
    isRequired: true,
},
        created_at: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};